(function (angular) {
  "use strict";

  var MIN_CONTAINER_PADDING_PX = 30;

  angular.module("Toyota.Directives").directive("tyRangeSpinnerGradeSelector", [
    "$window",
    "$timeout",
    "$analytics",
    "CssMediaWatcher",
    function ($window, $timeout, $analytics, CssMediaWatcher) {
      var controller = [
        "DebugLogger",
        "$scope",
        "$element",
        function (DebugLogger, $scope) {
          var ctl = this;

          function init() {
            $scope.$watch(
              "tyRangeSpinnerGradeSelector.selectedGradeId",
              function (newSelectedGradeId, oldSelectedGradeId) {
                DebugLogger.log(
                  "tyRangeSpinnerGradeSelector",
                  "tyRangeSpinnerGradeSelector.selectedGradeId about to change to",
                  newSelectedGradeId
                );

                if (newSelectedGradeId === oldSelectedGradeId) {
                  DebugLogger.log(
                    "tyRangeSpinnerGradeSelector",
                    "tyRangeSpinnerGradeSelector.selectedGradeId aborted change to",
                    newSelectedGradeId,
                    " - same as the old ID"
                  );
                  return;
                }

                DebugLogger.log(
                  "tyRangeSpinnerGradeSelector",
                  "tyRangeSpinnerGradeSelector.selectedGradeId changed to",
                  newSelectedGradeId
                );
              }
            );

            $scope.gradesTabs = $scope.tyRangeSpinnerGradeSelector.grades.map(function (grade) {
              return { title: grade.name, id: grade.id, gradeId: grade.id };
            });
          }

          ctl.changeGradeId = function (grade) {
            var newSelectedGradeId = grade.id;
            var oldSelectedGradeId = ctl.selectedGradeId;

            ctl.triggerGradeActiveSelectionAnalyticsEvent(grade.title ?? grade.name);

            DebugLogger.log(
              "tyRangeSpinnerGradeSelector",
              "tyRangeSpinnerGradeSelector.selectedGradeId about to change to",
              newSelectedGradeId
            );

            if (newSelectedGradeId === oldSelectedGradeId) {
              DebugLogger.log(
                "tyRangeSpinnerGradeSelector",
                "tyRangeSpinnerGradeSelector.selectedGradeId aborted change to",
                newSelectedGradeId,
                " - same as the old ID"
              );
              return;
            }

            DebugLogger.log(
              "tyRangeSpinnerGradeSelector",
              "tyRangeSpinnerGradeSelector.selectedGradeId changed to",
              newSelectedGradeId
            );
            emitChange(newSelectedGradeId);
          };

          ctl.$onInit = init;

          function emitChange(selectedGradeId) {
            ctl.onSelectedGradeIdChange(selectedGradeId);
          }

          ctl.triggerGradeActiveSelectionAnalyticsEvent = function (gradeName) {
            $analytics.eventTrack("selectGrade", {
              eventType: "click",
              category: gradeName,
            });
          };
        },
      ];

      var link = function ($scope, $element, $attrs, $ctrl, $transclude) {
        $transclude($scope, function (clone) {
          $element.append(clone);
        });

        var cssMediaWatcher = CssMediaWatcher({
          $el: $element,
          pseudoEl: "before",
          mediaProperty: "viewportWidth",
          mediaRegexes: {
            mobile: "^mobile$",
            tablet: "^tablet$",
            desktop: "^desktop$",
          },
        });

        var $gradeItemsContainer = $element.find('[data-js="ty-range-spinner-grade-selector-items-container"]');

        function init() {
          $scope.$watch("tyRangeSpinnerGradeSelector.selectedGradeId", function () {
            updateScrollPosition();
          });

          $scope.$watch("tyRangeSpinnerGradeSelector.grades", function () {
            $timeout(function () {
              updatePadding();
              updateScrollPosition();
            });
          });

          angular.element($window).resize(updatePadding);

          $scope.$on("did-detect-mouse", function () {
            angular.element($window).off("resize", updatePadding);
            $gradeItemsContainer.css("white-space", "");
            resetToDefault();
          });
        }

        init();

        function getSelectedGradeItem() {
          var $gradeSelectorItems = $gradeItemsContainer.find("[data-js='ty-range-spinner-grade-selector-item']");
          return $gradeSelectorItems.filter(":has(> :checked)");
        }

        function updateScrollPosition(animationDuration) {
          var $selectedItem = getSelectedGradeItem();

          if ($selectedItem.length === 0) {
            return;
          }

          var selectedItem = $selectedItem[0].getBoundingClientRect();
          var selectedItemMidpoint = (selectedItem.right + selectedItem.left) / 2;
          var windowMidpoint = angular.element($window).width() / 2;

          var scrollAmount = selectedItemMidpoint - windowMidpoint;
          var currentScrollPosition = $gradeItemsContainer.scrollLeft();
          var scrollToPosition = currentScrollPosition + scrollAmount;

          $gradeItemsContainer.animate({ scrollLeft: scrollToPosition }, animationDuration);
        }

        var isScrollable = false;

        function updatePadding() {
          var $gradeSelectorItems = $element.find("[data-js='ty-range-spinner-grade-selector-item']");
          if ($gradeSelectorItems.length === 0) {
            return;
          }

          var viewportWidth = cssMediaWatcher.getCurrentMedia().viewportWidth;

          if (!viewportWidth.is.mobile) {
            $gradeItemsContainer.css("white-space", "");
            resetToDefault();
            return;
          }

          $gradeItemsContainer.css("white-space", "nowrap");

          var $firstItem = $gradeSelectorItems.first();
          var firstItem = $firstItem[0].getBoundingClientRect();
          var $lastItem = $gradeSelectorItems.last();
          var lastItem = $lastItem[0].getBoundingClientRect();

          var containerWidth = $element.outerWidth();
          var contentWidth = lastItem.right - firstItem.left;

          if (contentWidth <= containerWidth - MIN_CONTAINER_PADDING_PX) {
            resetToDefault();
            return;
          }

          var firstItemWidthIncludingMargin = $firstItem.outerWidth(true);
          var lastItemWidthIncludingMargin = $lastItem.outerWidth(true);

          var paddingLeft = containerWidth / 2 - firstItemWidthIncludingMargin / 2;
          var paddingRight = containerWidth / 2 - lastItemWidthIncludingMargin / 2;

          $gradeItemsContainer.css("padding-left", paddingLeft);
          $gradeItemsContainer.css("padding-right", paddingRight);
          $gradeItemsContainer.css("text-align", "left");

          if (isScrollable === false) {
            updateScrollPosition(0);
            isScrollable = true;
          }
        }

        function resetToDefault() {
          $gradeItemsContainer.css("padding-left", "");
          $gradeItemsContainer.css("padding-right", "");
          $gradeItemsContainer.css("text-align", "");
          isScrollable = false;
        }
      };

      return {
        bindToController: {
          grades: "<",
          selectedGradeId: "<",
          onSelectedGradeIdChange: "<",
          gradeSelectionGoalId: "@gradeSelectionGoalId",
        },
        controller: controller,
        controllerAs: "tyRangeSpinnerGradeSelector",
        link: link,
        restrict: "A",
        scope: {},
        transclude: true,
      };
    },
  ]);
})(window.angular);
